import { combineReducers } from "redux";

import {
  AnalyticsListItem,
  AnalyticsReport,
  AnalyticsTimeSeriesRecord,
  AnalyticsCount,
  Chatter,
  ChatterNew, // This is to replace `Chatter` when convo filtering is released
  Client,
  Conversation,
  CSATSettings,
  Language,
  MessageTemplate,
  Response,
  ResponseFilterItem,
  ResponseSideBar,
  StatsAnswersOverviewRecord,
  StatsAnswersPerformanceRecord,
  StatsConversationsOverviewRecord,
  StatsSatisfactionRecord,
  User,
  Agent
} from "resourceModels";

import createResourceReducer from "./createResourceReducer";

export default combineReducers([
  AnalyticsListItem,
  AnalyticsReport,
  AnalyticsTimeSeriesRecord,
  AnalyticsCount,
  Chatter,
  ChatterNew, // This is to replace `Chatter` when convo filtering is released
  Client,
  Conversation,
  CSATSettings,
  Language,
  MessageTemplate,
  Response,
  ResponseFilterItem,
  ResponseSideBar,
  StatsAnswersOverviewRecord,
  StatsAnswersPerformanceRecord,
  StatsConversationsOverviewRecord,
  StatsSatisfactionRecord,
  User,
  Agent
].reduce((result, Model) => ({
  ...result,
  [Model.type]: createResourceReducer(Model)
}), {}));
